const style = {
    container: {
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgba(0,0,0,0.7)",
    },
    containerBox: {
      padding: "40px",
      width: "100%",
      maxWidth: 450,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "#1e212b",
      borderRadius: "12px",
      border: "1px solid #2a2f3b",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
    },
    title: {
      fontSize: 22,
      color: "#FFF",
      fontWeight: 600,
      marginBottom: 25,
      textAlign: "center",
    },
    qrCodeContainer: {
      width: 300,
      height: 300,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "white",
      borderRadius: 12,
      padding: 10,
      boxSizing: "border-box",
      position: "relative",
    },
    qrCode: {
      borderRadius: 8,
    },
    valueAndButtons: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 25,
      width: "100%",
      gap: 12,
    },
    valueAndButtonsCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: 15,
    },
    valueTitle: {
      fontSize: 14,
      fontWeight: 500,
      color: "#aeb9c4",
      textTransform: "uppercase",
    },
    valueValue: {
      fontSize: 28,
      fontWeight: 700,
      color: "#4ecf78",
    },
    verifyPaymentButton: {
      width: "100%",
      height: 45,
      borderRadius: 10,
      background: "#4ecf78",
      fontSize: 16,
      fontWeight: 600,
      color: "#1e212b",
      cursor: "pointer",
      border: 0,
      outline: "none",
    },
    exitButton: {
      width: "100%",
      height: 45,
      borderRadius: 10,
      background: "#2a2f3b",
      fontSize: 16,
      fontWeight: 600,
      color: "#aeb9c4",
      cursor: "pointer",
      border: "1px solid #3c4257",
      outline: "none",
    },
  };
  
  export default style;
  